import React from 'react';
import { NumberInput, NumberInputProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { COLORS, INPUT_LABEL_FONT_SIZE } from '../../../src/constants/theme';

export interface ThemedNumberInputProps extends NumberInputProps {
  // All NumberInput props are available
}

export const ThemedNumberInput: React.FC<ThemedNumberInputProps> = ({
  label,
  styles = {},
  size,
  ...props
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const defaultStyles = {
    label: {
      color: '#f2f2f2',
      marginBottom: '4px',
      fontWeight: 500,
      fontSize: INPUT_LABEL_FONT_SIZE,
    },
    description: {
      color: COLORS.textDimmed,
      fontSize: '0.75rem',
      marginTop: '3px',
      lineHeight: 1.4,
    },
    input: {
      backgroundColor: 'rgba(30, 30, 30, 0.6)',
      borderColor: 'rgba(255, 255, 255, 0.22)',
      color: '#f2f2f2',
      fontSize: isMobile ? '0.875rem' : '1rem',
      '&::placeholder': {
        color: COLORS.textDimmed,
      },
      '&:focus': {
        borderColor: '#EA580C',
      },
      '&:hover': {
        borderColor: '#555',
      },
      // Merge any custom input styles
      ...(styles as any)?.input,
    },
    control: {
      color: '#f2f2f2',
      borderColor: 'rgba(255, 255, 255, 0.22)',
      '&:hover': {
        backgroundColor: '#333',
        borderColor: '#EA580C',
      },
    },
  };

  return (
    <NumberInput
      label={label}
      size={size || (isMobile ? 'sm' : 'md')}
      styles={defaultStyles}
      {...props}
    />
  );
};

export default ThemedNumberInput;
